import { useRouter } from 'next/router';

import { Pagination } from '@/core/components/Pagination';
import { routePaths } from '@/core/constants/routes';
import { ResourceLink } from '@/core/components/ResourceLink';

import { RequestResponse } from '@/utils/request.types';

import {
  ListWrapper,
  Wrapper,
} from './MediaList.styles';
import { MediaLinksData } from '../media.types';

type MediaListProps = {
  data: RequestResponse<MediaLinksData>;
}

export const MediaList = ({ data }: MediaListProps) => {
  const { push } = useRouter();

  const {
    data: list,
    meta,
  } = data;

  const handlePageChange = (newPage: number) => {
    push({
      pathname: routePaths.inTheNews,
      query: { page: newPage },
    });
  };

  return (
    <Wrapper>
      <ListWrapper>
        {list.map(link => (
          <ResourceLink
            key={link.id}
            data={link}
          />
        ))}
      </ListWrapper>
      {meta.pagination && (
        <Pagination
          currentPage={meta.pagination.page}
          pageSize={meta.pagination.pageSize}
          total={meta.pagination.total}
          totalPageCount={meta.pagination.pageCount}
          onPageChange={handlePageChange}
        />
      )}
    </Wrapper>
  );
};
